export default __webpack_public_path__ + "2d63962f9476024d5a4b2ff4e24ca214.png";